import { Route, Routes } from 'react-router-dom'
import { DashboardList } from './components/DashboardList'
import { accountStatusSelector } from 'redux/login/selectors'
import { useAppSelector } from 'redux/hooks'
import { ACCOUNT_STATUSES } from 'api/auth/constants'
import { PendingForApproval } from 'modules/PendingForApproval'

export const Dashboard = () => {
  const accountStatus = useAppSelector(accountStatusSelector)

  return (
    <Routes>
      <Route
        path="/"
        element={
          accountStatus !== ACCOUNT_STATUSES.APPROVED ? (
            <PendingForApproval />
          ) : (
            <DashboardList />
          )
        }
      />
      <Route path="/:companyId" element={<DashboardList />} />
    </Routes>
  )
}
